<template>
  <div class="menucontrol-scroll fixed-top">
    <Banner />
    <AuthorTable />
  </div>
</template>
<script>
import Banner from "./components/Banner.vue";
import AuthorTable from "./components/AuthorTable.vue";
export default {
  components: {
    Banner,
    AuthorTable,
  },
};
</script>
